import React from 'react';

import Section from '../_common/Section';
import SectionHeaderSkeleton from '../_common/SectionHeaderSkeleton';
import { SelectFieldSkeleton } from '../_common/SelectFieldSkeleton';

export function ListingsSkeleton() {
  return (
    <Section>
      <SectionHeaderSkeleton />
      <SelectFieldSkeleton />
    </Section>
  );
}
